import app from '@/app.js'
import { component } from 'picoapp'
import { zelektor, loopify } from '@/lib/utility-functions.js'
import { getSizedImageUrl, imageSize } from '@/lib/images.js'
import { formatMoney } from '@/lib/currency.js'

export default component((node, ctx) => {
    /*******************************************************************************************************************************************/
    /* Data + Elements
    /*******************************************************************************************************************************************/
    const { toggle: toggles = [], cartCount, total, itemWrapper } = zelektor(node)
    const cartParam = [...new URLSearchParams(window.location.search).keys()].find(k => k === 'cart')


    /*******************************************************************************************************************************************/
    /* Event Listeners
    /*******************************************************************************************************************************************/
    loopify(toggles).forEach(toggle => toggle.addEventListener('click', close))

    ctx.on('cart:toggle', ({ cart, cartOpen }) => {
        if (cartOpen) open(cart)
    })

    ctx.on('cart:updated', () => {
        render(ctx.getState().cart)
        ctx.emit('cart:toggle', (state) => {
            return {
                cartOpen: !state.cartOpen,
            }
        })
        app.mount()
    })


    /*******************************************************************************************************************************************/
    /* Initialize
    /*******************************************************************************************************************************************/
    render(ctx.getState().cart)
    updateCartCount(ctx.getState().cart.item_count)

    ctx.on('cart:updated', (state) => {
        updateCartCount(state.cart.item_count)  
    })

    if (cartParam) {
        ctx.emit('cart:toggle', (state) => {
            return {
                cartOpen: !state.cartOpen,
            }
        })
    }


    /*******************************************************************************************************************************************/
    /* Render
    /*******************************************************************************************************************************************/
    function render(cart) {
        itemWrapper.innerHTML = renderItems(cart.items)
        total.innerText = formatMoney(cart.total_price)
    }


    /*******************************************************************************************************************************************/
    /* Open
    /*******************************************************************************************************************************************/
    function open(cart) {
        node.classList.add('is-open')
        setTimeout(() => {
            node.classList.add('is-open')
            setTimeout(render(cart), 10)
            app.mount()
        }, 50)
    }


    /*******************************************************************************************************************************************/
    /* Close
    /*******************************************************************************************************************************************/
    function close() {
        node.classList.remove('is-open')
        setTimeout(() => {
            node.classList.remove('is-open')
            app.hydrate({ cartOpen: false })
        }, 400)
    }


    /*******************************************************************************************************************************************/
    /* Update Cart Count
    /*******************************************************************************************************************************************/
    function updateCartCount(count) {
        count > 0 ? cartCount.innerText = count : cartCount.innerText = '0'
    }


    /*******************************************************************************************************************************************/
    /* Create Item
    /*******************************************************************************************************************************************/
    function createItem({
            variant_id: id,
            product_title: title,
            line_price: price,
            variant_title: color,
            image,
            url,
            quantity,
            options_with_values: options,
            variant_options: optionValues,
            ...item // eslint-disable-line
    }) {
            const imgSrc =  image
                            ? getSizedImageUrl(
                                image.replace('.' + imageSize(image), ''),
                                '180x180' // TODO hacky af
                            )
                            : 'https://source.unsplash.com/R9OS29xJb-8/2000x1333'

            const imgSrcLazy =  image
                                ? getSizedImageUrl(
                                    image.replace('.' + imageSize(image), ''),
                                    '1x'
                                )
                                : 'https://source.unsplash.com/R9OS29xJb-8/2000x1333'
            
            let size
            const sizeOptionIndex = options.indexOf(options.find(o => o.name === 'Size' || o.name === 'size'))
            if (sizeOptionIndex != -1)
                size = optionValues[sizeOptionIndex]
        
            return  `
                    <li class="cart-drawer__item" data-id="${id}" data-component="cartDrawerItem">
                        <figure class="cart-drawer__item__image">
                            <img src="${imgSrcLazy}" data-src="${imgSrc}" alt="${title}" class="lazyload">
                        </figure>
                        <article class="cart-drawer__item__inner">
                            <div class="cart-drawer__item__inner__left">
                                <p class="cart-drawer__item__title">${title}</p>
                                <p class="cart-drawer__item__size">${size ? `${window.theme.strings.cart.size}: ${size}` : ''}</p>
                                <div class="quantity">
                                    <button type="button" class="quantity__control js-decrease">-</button>
                                    <input type="number" class="quantity__value js-quantity" value="${quantity}" readonly>
                                    <button type="button" class="quantity__control js-increase">+</button>
                                </div>
                            </div>
                            <div class="cart-drawer__item__inner__right">
                                <button type="button" class="cart-drawer__item__remove-button js-remove">${theme.strings.cart.remove}</button>
                                <p class="cart-drawer__item__price">${formatMoney(price)}</p>
                            </div>
                        </article>
                        <a href="${url}" class="cart-drawer__item__link"></a>
                    </li>
                    `
    }
    

    /*******************************************************************************************************************************************/
    /* Render Items
    /*******************************************************************************************************************************************/
    function renderItems(items) {
        return  items.length > 0
                ? items.reduce((markup, item) => {
                    markup += createItem(item)
                    return markup
                }, '')
                : `<li class="cart-drawer__empty">${theme.strings.cart.empty}</li>`
    }
})